module.exports = __webpack_public_path__ + "static/media/bus-eireann.0e428ada.png";